/*

Array of object

Top level object can be:
1. Header
2. Group (Group can have navItems as children)
3. navItem

* Supported Options

/--- Header ---/

header

/--- nav Grp ---/

title
icon (if it's on top level)
tag
tagVariant
children

/--- nav Item ---/

icon (if it's on top level)
title
route: [route_obj/route_name] (I have to resolve name somehow from the route obj)
tag
tagVariant

*/
/* import dashboard from './dashboard'
import appsAndPages from './apps-and-pages'
import others from './others'
import chartsAndMaps from './charts-and-maps'
import uiElements from './ui-elements'
import formAndTable from './forms-and-table' */

import UsersNavigation from "@/views/users/navigation/index";
import SettingsNavigation from "@/views/settings/navigation/index";
import CatalogueNavigation from "@/views/catalogue/navigation/index";
// import CheckbookNavigation from "@/views/checkbook/navigation/index";

const zergSections = [
    ...UsersNavigation,
    ...SettingsNavigation,
    // ...CheckbookNavigation,
    ...CatalogueNavigation,
];

// // Array of sections
export default zergSections;
